module.exports = __webpack_public_path__ + "static/img/14000067.874fe5ba.png";